import { render, staticRenderFns } from "./TestimonySection.vue?vue&type=template&id=fa761f80&scoped=true&"
import script from "./TestimonySection.vue?vue&type=script&lang=js&"
export * from "./TestimonySection.vue?vue&type=script&lang=js&"
import style0 from "./TestimonySection.vue?vue&type=style&index=0&id=fa761f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa761f80",
  null
  
)

export default component.exports